/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Requestcompanions1Inputs */

const en_requestcompanions1 = /** @type {(inputs: Requestcompanions1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const de_requestcompanions1 = /** @type {(inputs: Requestcompanions1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

/**
* | output |
* | --- |
* | "+{count}" |
*
* @param {Requestcompanions1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestcompanions1 = /** @type {((inputs: Requestcompanions1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestcompanions1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestcompanions1(inputs)
	return de_requestcompanions1(inputs)
});
export { requestcompanions1 as "requestCompanions" }